import React from 'react'
import ModalWrapper from "./ModalWrapper";
import {useDispatch, useSelector} from "react-redux";
import {actionsState as ProjectStore} from "../Redux/project";
import {getStrLang} from "../Helpers/functions";
const SaveInfo = ()=>{
    const dispatch = useDispatch();
    const saveResult = useSelector(store=>store.project.saveResult);
    return <ModalWrapper
        title={ getStrLang('c3d_YBYDd') }
        onClose={()=>dispatch(ProjectStore.setModal(''))}
    >
        <div className={"save-block"}>
            <div className={"scrolled"}>
                <p className="save-block__succsess">
                    { getStrLang('c3d_rFsGg') }
                </p>
                <div className="save-block__lable">{ getStrLang('c3d_VFeXR') }</div>
                <div className="save-block__hash-block">
                    <input className="save-block__hashcode" type="text" readOnly={true} value={saveResult.hash}/>
                    <button className="save-block__copy-btn"
                            onClick={() => {navigator.clipboard.writeText(saveResult.hash)}}
                    >{ getStrLang('c3d_pCZnp') }</button>
                </div>
                <div className="save-block__lable">{ getStrLang('c3d_AjJ3d') }</div>
                <div className="save-block__hash-block">
                    <input className="save-block__hashcode npr" type="text" readOnly={true} value={saveResult.href}/>
                    <button className="save-block__copy-btn"
                            onClick={() => {navigator.clipboard.writeText(saveResult.href)}}
                    >{ getStrLang('c3d_pCZnp') }</button>
                </div>
                <div className="save-block__info">
                    <p className="save-block__info_blue">{ getStrLang('c3d_RasaG') }</p>
                    <p>{ getStrLang('c3d_FGr88') }</p>
                    <p>{ getStrLang('c3d_C0Vvg') }</p>
                    <div>
                        <button className="save-block__quiz-btn">{ getStrLang('c3d_EAKSh') }</button>
                    </div>
                </div>
            </div>
        </div>
    </ModalWrapper>
}
export default SaveInfo
